import { clsx } from "clsx";
import {
  Bell,
  User,
  LogOut,
  ChevronDown,
} from "lucide-react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Navbar.module.scss";

const Navbar = ({
  variant = "client",
  user,
  onLogout,
  notifications = [],
}) => {
  const [showProfile, setShowProfile] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getModuleName = () => {
    const path = location.pathname;

    // Client paths
    if (path.startsWith("/app/dashboard")) return "Dashboard";
    if (path.startsWith("/app/clients")) return "Clients";
    if (path.startsWith("/app/sessions") || path.startsWith("/app/bookings")) return "Sessions";
    if (path.startsWith("/app/attendance")) return "Attendance";
    if (path.startsWith("/app/notifications")) return "Notifications";
    if (path.startsWith("/app/reminders")) return "Reminders";
    if (path.startsWith("/app/feedback")) return "Feedback";
    if (path.startsWith("/app/programs")) return "Programs";
    if (path.startsWith("/app/nutrition")) return "Nutrition";
    if (path.startsWith("/app/payments")) return "Payments";
    if (path.startsWith("/app/revenue")) return "Revenue";
    if (path.startsWith("/app/reports")) return "Reports";
    if (path.startsWith("/app/settings")) return "Settings";
    if (path.startsWith("/app/profile")) return "Profile";
    if (path.startsWith("/app/subscription")) return "Subscriptions";
    if (path.startsWith("/app/trainers")) return "Trainers";
    if (path.startsWith("/app/exercises")) return "Exercise Library";
    if (path.startsWith("/app/workouts")) return "Workout Plans";
    if (path.startsWith("/app/schedule")) return "Schedule";
    if (path.startsWith("/app/leads")) return "Leads (CRM)";
    if (path.startsWith("/app/inventory")) return "Inventory";
    if (path.startsWith("/app/pos")) return "POS";
    if (path.startsWith("/app/executive")) return "Executive";
    if (path.startsWith("/app/post")) return "Marketing Studio";

    // Super admin paths
    if (path.startsWith("/admin/dashboard")) return "Admin Dashboard";
    if (path.startsWith("/admin/businesses")) return "Businesses";
    if (path.startsWith("/admin/subscriptions")) return "Subscriptions";
    if (path.startsWith("/admin/orders")) return "Orders";
    if (path.startsWith("/admin/users")) return "Users";
    if (path.startsWith("/admin/revenue")) return "Revenue Reports";
    if (path.startsWith("/admin/reports")) return "System Reports";
    if (path.startsWith("/admin/settings")) return "System Settings";

    return "BizAura";
  };

  const handleProfileClick = () => {
    setShowProfile(false);
    navigate("/app/profile");
  };

  return (
    <header className={clsx(styles.navbar, styles[variant])}>
      <div className={styles.left}>
        {/* <h1 className={styles.moduleName}>{getModuleName()}</h1> */}
      </div>

      <div className={styles.right}>
        {/* Notifications */}
        <div className={styles.dropdown}>
          <button
            className={styles.iconButton}
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <Bell size={20} />
            {notifications.length > 0 && (
              <span className={styles.badge}>{notifications.length}</span>
            )}
          </button>

          {showNotifications && (
            <div className={styles.dropdownMenu}>
              <div className={styles.dropdownHeader}>
                <span>Notifications</span>
                <button className={styles.link}>Mark all read</button>
              </div>
              {notifications.length === 0 ? (
                <div className={styles.empty}>No notifications</div>
              ) : (
                notifications.map((notification) => (
                  <div key={notification.id} className={styles.notification}>
                    <p className={styles.notificationTitle}>{notification.title}</p>
                    <p className={styles.notificationTime}>{notification.time}</p>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* Profile */}
        <div className={styles.dropdown}>
          <button
            className={styles.profile}
            onClick={() => setShowProfile(!showProfile)}
          >
            <div className={styles.avatar}>
              <User size={18} />
            </div>
            <div className={styles.profileInfo}>
              <span className={styles.name}>{user?.name || "User"}</span>
              <span className={styles.role}>{user?.role || "Member"}</span>
            </div>
            <ChevronDown size={16} />
          </button>

          {showProfile && (
            <div className={styles.dropdownMenu}>
              <div className={styles.dropdownItem} onClick={handleProfileClick}>
                <User size={16} />
                <span>Profile</span>
              </div>
              <div className={styles.divider}></div>
              <div
                className={clsx(styles.dropdownItem, styles.danger)}
                onClick={onLogout}
              >
                <LogOut size={16} />
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
